export function getThumbImagePath(thumbnailPath) {
  return `${process.env.NEXT_PUBLIC_ROOT_URL}/${process.env.NEXT_PUBLIC_THUMBNAILS_IMAGE_PATH}/${thumbnailPath}`;
}
